import { render, staticRenderFns } from "./completeInvestigation.vue?vue&type=template&id=1edc2358&scoped=true"
import script from "./completeInvestigation.vue?vue&type=script&lang=js"
export * from "./completeInvestigation.vue?vue&type=script&lang=js"
import style0 from "./completeInvestigation.vue?vue&type=style&index=0&id=1edc2358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edc2358",
  null
  
)

export default component.exports